import { Component, inject, Inject } from '@angular/core';
import { EmploymentDetails } from '../../data/employment-details';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { LookupDataService } from '../../services/lookup-data.service';
import { LookupItem, LookupValueMapper } from '../../models/lookup-item';
import { AssessmentService } from '../../services/assessment.service';
import {  NonNullableFormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-employment-dialog',
  templateUrl: './employment-dialog.component.html',
  styleUrl: './employment-dialog.component.scss'
})
export class EmploymentDialogComponent {

  assessmentService = inject(AssessmentService);
  formBuilder = inject(NonNullableFormBuilder);

  submitForm = false;
  model: EmploymentDetails;
  countries!:LookupItem[];

  constructor(
    public dialogRef: MatDialogRef<EmploymentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { model: EmploymentDetails, countries: LookupItem[]}
  ) {
    this.model = data.model || new EmploymentDetails();
    this.countries = data.countries;
  }

    ngOnInit(): void {    
      this.handleFormModelBinding();
    }

    handleFormModelBinding() {
      
      // Bind form to model data
      this.roleForm?.patchValue({
        ...this.model,
        employerCountry: LookupValueMapper.toLookupItem(this.model.employerCountry)
      });   
      
      // Subscribe to form changes to update model
      this.roleForm?.valueChanges.subscribe(value => {
        this.model = {
          ...this.model!,
          ...value,
          employerCountry: LookupValueMapper.toLookupValue(value.employerCountry)
        }
      });
    }

  roleForm = this.formBuilder.group({
        employerName: ['', [Validators.required]],   
        employerCountry: [null as LookupItem | null],
        position: [''],
        start: [''],
        end: [''],
        responsibilities: ['']
      });


  close(): void {
    this.submitForm = true;
    if(this.roleForm.valid){
      this.dialogRef.close(this.model);
    }
    // If the form is invalid, stay open and show validation errors
    this.roleForm.markAllAsTouched();
    this.submitForm = false;
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
